"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorLocalizationByCode = void 0;
var _TranslationKey = require("../models/TranslationKey");
const getErrorLocalizationByCode = errorCode => {
  switch (errorCode) {
    case '105':
      return _TranslationKey.TranslationKey.validationRequired;
    case '106':
      return _TranslationKey.TranslationKey.validationRegex;
    case '119':
      return _TranslationKey.TranslationKey.validationLength;
    case '166':
      return _TranslationKey.TranslationKey.validationZipCodeStructure;
    default:
      return _TranslationKey.TranslationKey.errorOccurred;
  }
};
exports.getErrorLocalizationByCode = getErrorLocalizationByCode;
//# sourceMappingURL=getErrorLocalizationByCode.js.map